import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { PhaseDuration } from 'Cube/domain/cube.domain.types'
import {
  stepDataAtomFactory,
  stepValidationAtomFactory
} from '../../../../atoms'

/**
 * TODO/Pondering - these atoms are set up as families because it allows
 * them to be automatically plumbed into a task scope, without the need to manually
 * plumb all of the primitives of that step into the task to use them. However,
 * if we consider that some of the atoms 'domains' can - and potentially should -
 * be reusable across the application, then maybe this automated plumbing isn't currently
 * suitable.
 *
 * It's easier for plumbing the task, sure, but it does subsequently couple the primitives
 * to that task scope, rather than being truly reusable. The DevExp of setting up a task
 * is currently rather nice, though!
 *
 * As part of task I/O I'll have a look to see if I can find a solution which retains the
 * nice DevExp of setting up the task, but keeps the primitives decoupled. We'll very likely need
 * some kind of 'syncing' mechanism - but if we make that quite easy to set up (basically
 * just setting up the hook in the step root component) then that should be reasonable.
 *
 * It's not a huge deal in the short term, as these primitives below can be easily tweaked/swapped
 * with minor impact to the non-primitive atoms anyway. It's really about where these primitives live,
 * scope wise!
 *
 * ---
 *
 * 'Primitives' but are part of the stepData primitive that is, by default,
 * set up in the Task component using StepMap. Therefore we don't need
 * to actively plumb these! They will 'just work' in the task as long
 * as the stepData primitive is set up.
 *
 * These should not be exported outside of this file.
 */
export type ApiPhase =
  DashboardApi20240730.GetBillingSchedule.BillingSchedulePhase
type ApiPrice = DashboardApi20240730.GetPrice.Price

export type Phase = Omit<ApiPhase, 'startDate' | 'endDate' | 'discounts'> & {
  duration: PhaseDuration
  discounts: Array<PhaseDiscount>
}
export type PhaseMinimum = DashboardApi20240730.GetBillingSchedule.PhaseMinimum
export type PhaseDiscount =
  DashboardApi20240730.GetBillingSchedule.PhaseDiscount & {
    boundingBoxIndex: number
  }

export type Price = Omit<ApiPrice, 'createdAt' | 'productId'> & {
  productId?: string
}

export type ReviewPricingStepData = {
  startDate: Date
  recurrenceDayOfMonth: number
  purchaseOrderNumber: string
  label: string
  defaultDueDateDays?: number
  memo: string
  phases: Array<Phase>
  prices: Array<Price>
}

export type ArrCalculation = 'INCLUDE' | 'EXCLUDE'
export type BillingFrequency = Price['billingFrequency']

export const pricingDetailsAtom = stepDataAtomFactory('REVIEW_PRICING')
export const reviewPricingValidationAtom =
  stepValidationAtomFactory('REVIEW_PRICING')
